//eslint-disable-next-line
export const validEmailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

//eslint-disable-next-line
export const validZipRegex = /^\d{5}(?:[-\s]\d{4})?$/

//eslint-disable-next-line
export const numberWithCommasRegex = /\B(?=(\d{3})+(?!\d))/g
